import { render, staticRenderFns } from "./c_tab_input.vue?vue&type=template&id=21392f38&scoped=true"
import script from "./c_tab_input.vue?vue&type=script&lang=js"
export * from "./c_tab_input.vue?vue&type=script&lang=js"
import style0 from "./c_tab_input.vue?vue&type=style&index=0&id=21392f38&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21392f38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21392f38')) {
      api.createRecord('21392f38', component.options)
    } else {
      api.reload('21392f38', component.options)
    }
    module.hot.accept("./c_tab_input.vue?vue&type=template&id=21392f38&scoped=true", function () {
      api.rerender('21392f38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_tab_input.vue"
export default component.exports